import { Table, Tag } from "antd";
import moment from "moment";

function UpcomingMeetings({ data }: any) {
  const columns : any= [
    {
      title: "No",
      key: "no",
      width: 60,
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Corporate",
      dataIndex: ["investors", "company"],
      key: "corporate",
    },
    {
      title: "Corporate Status",
      dataIndex: "status",
      key: "corporateStatus",
      render: (val: any, record: any) => {
        if (record?.vc_checkout) {
          return (
            <Tag color="red" style={{ minWidth: 110, textAlign: "center" }}>
              Checked Out
            </Tag>
          );
        } else if (record?.vc_checkin) {
          return (
            <Tag color="green" style={{ minWidth: 110, textAlign: "center" }}>
              Checked In
            </Tag>
          );
        } else {
          return (
            <Tag color="#cfc89b" style={{ minWidth: 110, textAlign: "center" }}>
              Not yet
            </Tag>
          );
        }
      },
    },
    { title: "Time", dataIndex: "slot", key: "time",width:150 },
    { title: "Room", dataIndex: ["investors", "meeting_room"], key: "room",width:10 },
    { title: "Startup", dataIndex: "startup_name", key: "startup" },
    {
      title: "Startup Status",
      dataIndex: "status",
      key: "startupStatus",
      render: (val: any, record: any) => {
       
        if (record?.su_checkout) {
          return (
            <Tag color="red" style={{ minWidth: 110, textAlign: "center" }}>
              Checked Out
            </Tag>
          );
        } else if (record?.su_checkin) {
          return (
            <Tag color="green" style={{ minWidth: 110, textAlign: "center" }}>
              Checked In
            </Tag>
          );
        } else {
          return (
            <Tag color="#cfc89b" style={{ minWidth: 110, textAlign: "center" }}>
              Not yet
            </Tag>
          );
        }
      },
    },
    {
      title: "Meeting Status",
      dataIndex: "meeting_status",
      key: "meeting_status",
      render: (val: any, record: any) => {
        if (record?.status === false) {
          return (
            <Tag color="red" style={{
              minWidth: 110,
              textAlign: "center",
              color: "white",    
              backgroundColor: "red",
              border: "1px solid red", 
            }}>
              Meeting Cancelled
            </Tag>
          );
        }
        if (record?.meeting_end) {
          return (
            <Tag color="red" style={{ minWidth: 110, textAlign: "center" }}>
              Ended
            </Tag>
          );
        } else if (record?.meeting_start) {
          return (
            <Tag
              color="green-inverse"
              style={{ minWidth: 110, textAlign: "center" }}
            >
              Started
            </Tag>
          );
        } else {
          return (
            <Tag color="#cfc89b" style={{ minWidth: 110, textAlign: "center" }}>
              Not yet started
            </Tag>
          );
        }
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (item: any) => (
        <div style={{ fontSize: 12 }}>
          {moment(item).format("MMM D, YYYY h:mm:ss A")}
        </div>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (item: any) => (
        <div style={{ fontSize: 12 }}>
          {moment(item).format("MMM D, YYYY h:mm:ss A")}
        </div>
      ),
    },
    { title: "Updated By", dataIndex: "updated_by", key: "updatedBy" },
  ];

  return (
    <Table
      size="small"
      dataSource={data || []}
      rowKey="id"
      columns={columns}
      bordered={false}
      pagination={false}
      scroll={{ x: 1000 }}
    />
  );
}

export default UpcomingMeetings;
